export const ERROR_UPDATE = 'app/ERROR_UPDATE';
export const ERROR_CLEAR = 'app/ERROR_CLEAR';
export const UPDATE_APP = 'app/UPDATE';
export const CLEAR_SAME_SPOUSE = 'app/CLEAR_SAME_SPOUSE_CONFIRMED';
